const LA = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20513%20342'%3e%3crect%20y='0'%20fill='%230052B4'%20width='513'%20height='342'/%3e%3cg%20fill='%23D80027'%3e%3crect%20y='0.1'%20width='513'%20height='90.7'/%3e%3crect%20x='0'%20y='251.3'%20width='513'%20height='90.7'/%3e%3c/g%3e%3ccircle%20fill='%23FFFFFF'%20cx='256.5'%20cy='171'%20r='65.9'/%3e%3c/svg%3e";
export {
  LA as default
};
//# sourceMappingURL=LA.svg.es.js.map
